const initialState = {
    refDataEventsBySource: [],
    dbImportColumns: [],
    refDataConnectionDetails: [],
    serverFolderPaths: []
};
export default initialState;